<template>

  <div class="notification-wrapper" role="button" tabindex="0" @click="dismissNotification" @keydown.enter="dismissNotification" @keydown.space.prevent="dismissNotification">

    <v-banner
        class="justify-center banner-wrapper"
        elevation="2"
    >
      <template v-slot:prepend>
        <v-avatar
            :color="notification.type"
            :icon="icon"
            :size="30"
            class="icon-pop"
        ></v-avatar>
      </template>

      <v-banner-text style="font-size: 18px;">
        {{ displayMessage }}
      </v-banner-text>

      <!-- Progress bar -->
      <v-progress-linear
          :model-value="progress"
          height="3"
          rounded
          absolute
          class="notification-progress"
          :color="notification.type"
      />

    </v-banner>

  </div>

</template>

<script>

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

export default {

  name: "NotificationMessage",

  props: ['notification'],

  setup(props) {


    const store = useStore();
    const { t, te } = useI18n();
    const progress = ref(0);

    const displayMessage = computed(() => {
      const n = props.notification;
      if (n.messageKey && te(n.messageKey)) {
        return t(n.messageKey, n.messageParams || {});
      }
      return n.message || '';
    });

    let interval;
    let timeout;

    const DURATION = props.notification.duration || 5000;
    const STEP = 30;
    const INCREMENT = 100 / (DURATION / STEP);

    const clearDismissTimers = () => {
      clearInterval(interval);
      clearTimeout(timeout);
      interval = null;
      timeout = null;
    };

    const dismissNotification = () => {
      clearDismissTimers();
      store.dispatch('notifications/removeNotification', props.notification);
    };

    const icon = computed(() => {

      switch (props.notification.type) {

        case 'success': {
          return 'mdi-check-bold';
        }

        case 'warning': {
          return 'mdi-exclamation-thick';
        }

        case 'error': {
          return 'mdi-close-thick';
        }

        default: {
          return null;
        }

      }

    });

    onMounted(() => {

      interval = setInterval(() => {
        progress.value = Math.min(progress.value + INCREMENT, 100)
      }, STEP);

      timeout = setTimeout(() => {
        dismissNotification();
      }, DURATION);

    });

    onBeforeUnmount(() => {
      clearDismissTimers();
    })

    return {
      icon,
      progress,
      displayMessage,
      dismissNotification,
    }

  },

}
</script>

<style lang="scss" scoped>

.notification-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;
  animation: lift-in 0.35s ease-out;

  &:hover {
    transform: translateY(2px);
    transition: transform 0.2s ease;
  }

  .banner-wrapper {
    backdrop-filter: blur(6px);
    background: rgba(255, 255, 255, 0.95);
    border: none;
  }

  .notification-progress {
    top: unset !important;
    bottom: 0;
    opacity: 0.85;
    transition: opacity 0.2s ease;
  }

  .notification-wrapper:hover .notification-progress {
    opacity: 1;
  }

  .icon-pop {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    transform: scale(1);
    animation: pulse 1s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 5px rgba(0, 0, 0, 0);
      box-shadow-spread: 5px;
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }

  @keyframes lift-in {
    from {
      transform: translateY(-6px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  //.icon-pop {
  //  animation: friendly-pop 0.8s ease-out 1;
  //}
  //
  //@keyframes friendly-pop {
  //  0% {
  //    transform: scale(0.8);
  //    box-shadow: 0 0 0 0 rgba(var(--v-theme-primary), 0.4);
  //  }
  //
  //  60% {
  //    transform: scale(1.1);
  //    box-shadow: 0 0 0 8px rgba(var(--v-theme-primary), 0.15);
  //  }
  //
  //  100% {
  //    transform: scale(1);
  //    box-shadow: 0 0 0 0 rgba(var(--v-theme-primary), 0);
  //  }
  //}

}

</style>
